import React, { useEffect } from 'react';
import { SectionHeader } from '@havenengineering/module-shared-owners-ui/dist/components/SectionHeader';
import { useAuthContext } from '@havenengineering/module-shared-owners-ui/dist/contexts/auth';
import useSWRImmutable from 'swr/immutable';

import CategoryView from '../../components/Article/CategoryView/CategoryView';
import FacebookFeed from '../../components/Article/FacebookFeed/FacebookFeed';
import ImportantReads from '../../components/Article/ImportantReads/ImportantReads';
import BannerList from '../../components/BannerList';
import { swrLocalFetcher } from '../../helpers/fetch';
import { pageView } from '../../helpers/googleTag';
import styles from '../../styles/pages/news-and-information.module.scss';

const NewsAndInformation = () => {
  const { gtmPageViewAuthInfo, activeAccount } = useAuthContext();

  const { data: banners } = useSWRImmutable<Banner[]>(
    activeAccount?.parkCode && activeAccount?.vanYear
      ? `/contentful/banners?parkCode=${activeAccount.parkCode}&vanYear=${activeAccount.vanYear}&displayOn=homepage`
      : null,
    swrLocalFetcher
  );

  useEffect(() => {
    pageView(
      'news and info',
      '/ga-virtual/owners-account/news-and-info',
      'owners account',
      gtmPageViewAuthInfo
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h1 className="owners-heading-1">News and information</h1>
      {!!banners?.length && <BannerList banners={banners} />}
      <div className={styles.panelContainer}>
        <div className={styles.panel}>
          <SectionHeader title={'Important reads'} />
          {activeAccount && (
            <ImportantReads
              parkCode={activeAccount.parkCode}
              filterToImportant
            />
          )}
        </div>
        <div className={styles.panel}>
          <SectionHeader title={'Facebook feed'} />
          <FacebookFeed />
        </div>
      </div>
      <CategoryView showHowToGuides />
    </>
  );
};

export const getStaticProps = () => ({
  props: {
    pageTitle: 'News and information',
  },
  revalidate: 60 * 30,
});

export default NewsAndInformation;
